<app-social-media-footer></app-social-media-footer>
<!-- FOOTER -->
<footer class="footer">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-3 col-md-1">
                <div class="footerPart">
                    <a href="https://www.hydratight.com/en/ht-terms" target="_blank">{{ 'PAGE_FOOTER_TEXT.TERMS_AND_CONDITION' | transloco }}</a>
                    <a href="https://www.hydratight.com/en/ht-privacy" target="_blank">{{ 'PAGE_FOOTER_TEXT.PRIVACY_POLICY' | transloco }}</a>
                </div>
            </div>
            <div class="col-12">
                <div class="copyright text-center">
                    <p>© {{ this.currentYear }} {{ 'PAGE_FOOTER_TEXT.ALL_RIGHTS_RESERVED' | transloco }}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="container coockie-display modal-body" *ngIf="okDisplay === true">
        <p>
            {{ 'LANDING_PAGE.PRODUCT_DETAIL_TEXT.COMMENT' | transloco }}
            <a href="https://www.hydratight.com/en/ht-privacy" target="_blank">{{ 'LANDING_PAGE.PRODUCT_DETAIL_TEXT.PRIVACY_POLICY' | transloco }} </a>
        </p>
        <div class="coockies-butn">
            <a class="btn primary-ebtn" (click)="okOpen()">{{ 'LANDING_PAGE.BUTTONS_TEXT.OK' | transloco }}</a>
        </div>
    </div>
</footer>
<!-- FOOTER -->
